import axios from '@/api/config.js'
import {
  typingSingleBasicHistoryAPI,
  typingSingleIntermediateHistoryAPI,
  typingSingleAdvancedHistoryAPI,
  typingCombineIntermediateHistoryAPI,
  typingCombineAdvancedHistoryAPI,
  typingEssayPracticeHistoryAPI,
  typingEssayTestHistoryAPI
} from '@/api/typingAPI'
import i18n from '@/i18n'
import { secondToHMS } from '@/util/time'
import { roundDecimal } from '@/util/math'
import { countValues, sortObjectByKey } from '@/util/array'

const state = {
  typingSingleBasicHistory: [],
  typingSingleIntermediateHistory: [],
  typingSingleAdvancedHistory: [],
  typingCombineIntermediateHistory: [],
  typingCombineAdvancedHistory: [],
  typingEssayPracticeHistory: [],
  typingEssayTestHistory: [],
  fetchingTypingSingleBasicHistory: false,
  fetchingTypingSingleIntermediateHistory: false,
  fetchingTypingSingleAdvancedHistory: false,
  fetchingTypingCombineIntermediateHistory: false,
  fetchingTypingCombineAdvancedHistory: false,
  fetchingTypingEssayPracticeHistory: false,
  fetchingTypingEssayTestHistory: false
}

const getters = {

}

const mutations = {
  setTypingSingleBasicHistory (state, payload) {
    payload.map((each, index) => {
      each['correct_rate'] = roundDecimal(each['correct_rate'] * 100, 2) + '%'
      each['best_used_time'] = each['best_used_time'] + ' ' + i18n.t('Common.second')
      each['complete_used_time'] = secondToHMS(each['complete_used_time'], i18n.t('Common.hour'), i18n.t('Common.minute'), i18n.t('Common.second'))
    })
    state.typingSingleBasicHistory = payload
  },
  setTypingSingleIntermediateHistory (state, payload) {
    payload.map((each, index) => {
      each['correct_rate'] = roundDecimal(each['correct_rate'] * 100, 2) + '%'
      each['best_used_time'] = each['best_used_time'] + ' ' + i18n.t('Common.second')
      each['complete_used_time'] = secondToHMS(each['complete_used_time'], i18n.t('Common.hour'), i18n.t('Common.minute'), i18n.t('Common.second'))
    })
    state.typingSingleIntermediateHistory = payload
  },
  setTypingSingleAdvancedHistory (state, payload) {
    payload.map((each, index) => {
      if (each['incorrect_miss_records'] === 'no_incorrect_miss_records') {
        each['incorrect_miss_records'] = []
      } else {
        each['incorrect_miss_records'] = sortObjectByKey(countValues(each['incorrect_miss_records'].split('')))
      }
      if (each['complete_used_time']) {
        each['complete_used_time'] = secondToHMS(each['complete_used_time'], i18n.t('Common.hour'), i18n.t('Common.minute'), i18n.t('Common.second'))
      }
    })
    state.typingSingleAdvancedHistory = payload
  },
  setTypingCombineIntermediateHistory (state, payload) {
    payload.map((each, index) => {
      each['correct_rate'] = roundDecimal(each['correct_rate'] * 100, 2) + '%'
      each['best_used_time'] = each['best_used_time'] + ' ' + i18n.t('Common.second')
      each['complete_used_time'] = secondToHMS(each['complete_used_time'], i18n.t('Common.hour'), i18n.t('Common.minute'), i18n.t('Common.second'))
    })
    state.typingCombineIntermediateHistory = payload
  },
  setTypingCombineAdvancedHistory (state, payload) {
    payload.map((each, index) => {
      if (each['incorrect_miss_records'] === 'no_incorrect_miss_records') {
        each['incorrect_miss_records'] = []
      } else {
        each['incorrect_miss_records'] = sortObjectByKey(countValues(each['incorrect_miss_records'].split('')))
      }
      if (each['complete_used_time']) {
        each['complete_used_time'] = secondToHMS(each['complete_used_time'], i18n.t('Common.hour'), i18n.t('Common.minute'), i18n.t('Common.second'))
      }
    })
    state.typingCombineAdvancedHistory = payload
  },
  setTypingEssayPracticeHistory (state, payload) {
    payload.map((each) => {
      if (each['certified_level'] === 'None') {
        each['certified_level'] = i18n.t('Typing.certifiedLevel.none')
      }
      if (each['complete_used_time']) {
        each['complete_used_time'] = secondToHMS(each['complete_used_time'], i18n.t('Common.hour'), i18n.t('Common.minute'), i18n.t('Common.second'))
      }
    })
    state.typingEssayPracticeHistory = payload
  },
  setTypingEssayTestHistory (state, payload) {
    payload.map((each) => {
      if (each['certified_level'] === 'None') {
        each['certified_level'] = i18n.t('Typing.certifiedLevel.none')
      }
      if (each['complete_used_time']) {
        each['complete_used_time'] = secondToHMS(each['complete_used_time'], i18n.t('Common.hour'), i18n.t('Common.minute'), i18n.t('Common.second'))
      }
    })
    state.typingEssayTestHistory = payload
  },
  setFetchingTypingSingleBasicHistory (state, status) {
    state.fetchingTypingSingleBasicHistory = status
  },
  setFetchingTypingSingleIntermediateHistory (state, status) {
    state.fetchingTypingSingleIntermediateHistory = status
  },
  setFetchingTypingSingleAdvancedHistory (state, status) {
    state.fetchingTypingSingleAdvancedHistory = status
  },
  setFetchingTypingCombineIntermediateHistory (state, status) {
    state.fetchingTypingCombineIntermediateHistory = status
  },
  setFetchingTypingCombineAdvancedHistory (state, status) {
    state.fetchingTypingCombineAdvancedHistory = status
  },
  setFetchingTypingEssayPracticeHistory (state, status) {
    state.fetchingTypingEssayPracticeHistory = status
  },
  setFetchingTypingEssayTestHistory (state, status) {
    state.fetchingTypingEssayTestHistory = status
  }
}

const actions = {
  fetchTypingSingleBasicHistory ({ commit }, payload) {
    commit('setFetchingTypingSingleBasicHistory', true)
    axios.get(typingSingleBasicHistoryAPI)
      .then((response) => {
        commit('setTypingSingleBasicHistory', response.data)
        commit('setFetchingTypingSingleBasicHistory', false)
      }).catch((error) => {
        console.log('error:', error)
      })
  },
  fetchTypingSingleIntermediateHistory ({ commit }, payload) {
    commit('setFetchingTypingSingleIntermediateHistory', true)
    axios.get(typingSingleIntermediateHistoryAPI)
      .then((response) => {
        commit('setTypingSingleIntermediateHistory', response.data)
        commit('setFetchingTypingSingleIntermediateHistory', false)
      }).catch((error) => {
        console.log('error:', error)
      })
  },
  fetchTypingSingleAdvancedHistory ({ commit }, payload) {
    commit('setFetchingTypingSingleAdvancedHistory', true)
    axios.get(typingSingleAdvancedHistoryAPI)
      .then((response) => {
        commit('setTypingSingleAdvancedHistory', response.data)
        commit('setFetchingTypingSingleAdvancedHistory', false)
      }).catch((error) => {
        console.log('error:', error)
      })
  },
  fetchTypingCombineIntermediateHistory ({ commit }, payload) {
    commit('setFetchingTypingCombineIntermediateHistory', true)
    axios.get(typingCombineIntermediateHistoryAPI)
      .then((response) => {
        commit('setTypingCombineIntermediateHistory', response.data)
        commit('setFetchingTypingCombineIntermediateHistory', false)
      }).catch((error) => {
        console.log('error:', error)
      })
  },
  fetchTypingCombineAdvancedHistory ({ commit }, payload) {
    commit('setFetchingTypingCombineAdvancedHistory', true)
    axios.get(typingCombineAdvancedHistoryAPI)
      .then((response) => {
        commit('setTypingCombineAdvancedHistory', response.data)
        commit('setFetchingTypingCombineAdvancedHistory', false)
      }).catch((error) => {
        console.log('error:', error)
      })
  },
  fetchTypingEssayPracticeHistory ({ commit }, payload) {
    commit('setFetchingTypingEssayPracticeHistory', true)
    axios.get(typingEssayPracticeHistoryAPI)
      .then((response) => {
        commit('setTypingEssayPracticeHistory', response.data)
        commit('setFetchingTypingEssayPracticeHistory', false)
      }).catch((error) => {
        console.log('error:', error)
      })
  },
  fetchTypingEssayTestHistory ({ commit }, payload) {
    commit('setFetchingTypingEssayTestHistory', true)
    axios.get(typingEssayTestHistoryAPI)
      .then((response) => {
        commit('setTypingEssayTestHistory', response.data)
        commit('setFetchingTypingEssayTestHistory', false)
      }).catch((error) => {
        console.log('error:', error)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
